import { ErrorTypes } from '@wix/form-validator';
import { type PossibleValues } from '../../ui/form/types';
import { type VatIDValue } from './types';
import {
  VatIDType,
  brazilVatIdValidator,
  getVatIDType,
} from './brazil-vat-id-validator';
import { israelVatIdValidator } from './israel-vat-id-validator';
import { type ExternalData } from '../../types';

export const validateVatID = ({
  value,
  target,
  externalData,
}: {
  value?: PossibleValues;
  target: string;
  externalData?: ExternalData;
}) => {
  if (!value) {
    return undefined;
  }

  const country = externalData?.country;
  if (country === 'IL') {
    const isValid = israelVatIdValidator(value as VatIDValue);
    if (!isValid) {
      return {
        errorPath: target,
        errorType: ErrorTypes.FORMAT_ERROR,
        errorMessage: 'must match format "vat ID"',
        params: {
          format: 'custom IL field validations',
        },
      };
    }
    return undefined;
  }

  const isValid = brazilVatIdValidator(value as VatIDValue);
  if (!isValid) {
    return {
      errorPath: target,
      errorType: ErrorTypes.FORMAT_ERROR,
      errorMessage: 'must match format "vat ID"',
      params: {
        format: 'custom BR field validations',
      },
    };
  }
  return undefined;
};

export const getVatIDValue = (id: string, country: string) => {
  if (country === 'IL') {
    return { id, type: VatIDType.UNSPECIFIED };
  }

  const vatType = getVatIDType(id);
  return { id, type: vatType };
};
